import { mobileTopMPU1Id } from "../../common/_settings";
import { isMobile } from "../../common/_constants";

/* ----------------------
    Longitude Advert Containers:
*/
export const mobileTopMPU1 = () => {
    const noAdsPage = document.querySelector(".is-no-ads-page");
    if (!noAdsPage) {
        const paragraphElements = document.querySelectorAll(
            "#article-body > div > p",
        );
        // Check total count of paragraphs.
        // If total_count >= 4, then place ad after 4th paragraph; else place it on the last paragraph.
        const paragraphCount = paragraphElements.length;
        const advertPlacement =
            paragraphCount >= 4
                ? paragraphElements[3]
                : paragraphElements[paragraphCount];

        // Create Div for ad-mobileTopMpu1 Tag
        let mobileTopMpu1Container = document.createElement("div");
        mobileTopMpu1Container.classList.add("top-mpu-container");

        // Create Div for ad-mobileTopMpu1 Tag
        const mobileTopMpu1 = document.createElement("div");
        mobileTopMpu1.setAttribute("id", mobileTopMPU1Id);
        mobileTopMpu1.classList.add("sticky-advertising", "mobile-top-mpu");

        mobileTopMpu1Container.appendChild(mobileTopMpu1);

        const mobileTopMPU1Display = document.querySelector(
            ".body-content #ad-mobileTopMpu1",
        );

        // Place Div Tag after Fourth Paragraph of News Article
        // Only add the advert once
        if (!mobileTopMPU1Display && advertPlacement) {
            advertPlacement.parentNode.insertBefore(
                mobileTopMpu1Container,
                advertPlacement.nextSibling,
            );
        }
    }
};

export const removeSidebarAdvert = () => {
    const sidebarAdvertisingSectiion = document.querySelector(
        ".tsn-advertising-section",
    );
    const articlePage = document.querySelector(".article-page");
    const noAdsPage = document.querySelector(".is-no-ads-page");

    if (articlePage && sidebarAdvertisingSectiion && !noAdsPage) {
        if (isMobile()) {
            sidebarAdvertisingSectiion.style.display = "none";
        } else {
            sidebarAdvertisingSectiion.style.display = "block";
        }
    }
};

export const desktopTopMPU = () => {
    const desktopTopMpu1 = document.querySelector(".top-mpu-container");
    const desktopMPUContainer = document.querySelector(".zephr-feature_mpu-1");
    const isSectionFront = document.querySelector("body.section-page");
    const isHomepage = document.querySelector("body.homepage");
    const topNewsList = document.querySelector("[data-top-news-list]");
    const topLeadNews = document.querySelector("[data-top-news-lead]");

    if (!desktopTopMpu1) return;

    const revertMPUToOriginalLocation = () => {
        if (desktopMPUContainer && desktopTopMpu1) {
            desktopMPUContainer.insertBefore(
                desktopTopMpu1,
                desktopMPUContainer.firstChild,
            );
        }
    };

    const moveMPUToList = () => {
        if (topNewsList.childElementCount > 0 && desktopTopMpu1) {
            const thirdListItem =
                topNewsList.querySelector(
                    ".top-news__container:nth-child(3)",
                ) || topNewsList.lastElementChild;
            topNewsList.insertBefore(
                desktopTopMpu1,
                thirdListItem.nextElementSibling,
            );
        } else {
            topLeadNews.insertAdjacentElement("afterend", desktopTopMpu1);
        }
    };

    if (isSectionFront || isHomepage) {
        if (window.matchMedia("(max-width: 768px)").matches) {
            moveMPUToList();
        } else {
            revertMPUToOriginalLocation();
        }
    }
};

export const midBannerInArticleMobile = () => {
    const noAdsPage = document.querySelector(".is-no-ads-page");
    if (!noAdsPage) {
        const paragraphElements = document.querySelectorAll(
            "#article-body > div > p",
        );
        // Check total count of paragraphs.
        // If total_count >= 4, then place ad after 4th paragraph; else place it on the last paragraph.
        const paragraphCount = paragraphElements.length;
        const advertPlacement =
            paragraphCount >= 4
                ? paragraphElements[3]
                : paragraphElements[paragraphCount];

        // Create Div for ad-topBanner1 Tag
        let midBanner1Container = document.createElement("div");
        midBanner1Container.classList.add("midbanner-article-container");

        // Create Div for ad-topBanner1 Tag
        const midBanner1 = document.createElement("div");
        if (isMobile()) {
            midBanner1.setAttribute("id", "ad-topBanner1");
        } else {
            midBanner1.setAttribute("id", "ad-midbanner1");
        }

        midBanner1Container.appendChild(midBanner1);

        const midBanner1Display = document.querySelector(
            ".body-content #ad-midbanner1",
        );

        // Place Div Tag after Fourth Paragraph of News Article
        // Only add the advert once
        if (!midBanner1Display && advertPlacement) {
            advertPlacement.parentNode.insertBefore(
                midBanner1Container,
                advertPlacement.nextSibling,
            );
        }
    }
};

// We need to build the ad div container via JS to only load it
export const toggleDisplayMobileMidMPUTopBanner = () => {
    const container = document.querySelector(
        'div[data-testid="container--article_card_flex_group"]',
    );
    if (!container) return;

    const mobileAdvertContainer = document.querySelector(".mobile-adverts");
    if (!mobileAdvertContainer) return;

    const pageLayout = mobileAdvertContainer.getAttribute("data-layout");

    const existingAd = document.querySelector(
        '#ad-topBanner1[data-testid="advert--mobile-topbanner1"], #ad-midmpu1[data-testid="advert--mobile-midmpu1"]',
    );

    if (isMobile()) {
        if (existingAd) return;

        // Create Div for ad-topBanner1 Tag
        let advertContainer = document.createElement("div");

        if (pageLayout == "more_news_plugin") {
            advertContainer.setAttribute(
                "data-testid",
                "advert--mobile-midmpu1",
            );
            advertContainer.setAttribute("id", "ad-midmpu1");
        } else {
            advertContainer.classList.add("zephr-feature_top-banner-ad");
            advertContainer.setAttribute(
                "data-testid",
                "advert--mobile-topbanner1",
            );
            advertContainer.setAttribute("id", "ad-topBanner1");
        }

        mobileAdvertContainer.appendChild(advertContainer);
    } else {
        if (existingAd) existingAd.remove();
    }
};
